import { consumptionAPI, consumptionPublic } from "./clients";
const END_POINT = "/widgets";

const getWidgetData = widgetList => {
  return consumptionAPI.post(END_POINT, widgetList);
};

// requests public widgets based on the given magic link
const getPublicWidgetData = ({ widgetList, magicLink }) => {
  return consumptionPublic.post(`${END_POINT}/public`, widgetList);
};

export { getWidgetData, getPublicWidgetData };
